import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { useAuth } from '../contexts/AuthContext';

const FALLBACK_CONTEXT = {
  customer_id: 'default',
  sector: 'enterprise',
  customer_label: 'AERTA Pilot',
  sector_label: 'Enterprise',
  deployment_profile: 'enterprise',
  ot_power_utility_mode: false,
  public_documentation_url: null,
  llm_assist_enabled: false,
  llm_model: null,
  llm_operational: true,
  llm_reconnecting: false,
  llm_health: null,
  v_assist_enabled: false,
  v_nav_static_enabled: true,
  network_scan_enabled: false,
  network_scan_allowlist_required: false,
  network_scan_allowlist_rule_count: 0,
  network_scan_allowlist_gate_open: true,
  network_scan_cloud_api: false,
  network_scan_default_ports: null,
  pilot_mode: true,
};

export function usePilotContext() {
  const { user } = useAuth();
  const [context, setContext] = useState(FALLBACK_CONTEXT);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setLoading(false);
      return;
    }
    let mounted = true;
    async function load() {
      try {
        const data = await api.get('/api/env');
        if (mounted) setContext({ ...FALLBACK_CONTEXT, ...data });
      } catch {
        if (mounted) setContext(FALLBACK_CONTEXT);
      } finally {
        if (mounted) setLoading(false);
      }
    }
    load();
    const t = setInterval(() => {
      load();
    }, 60000);
    return () => {
      mounted = false;
      clearInterval(t);
    };
  }, [user?.email]);

  return { context, loading };
}
